import i from "react";
import e from "prop-types";
import f from "lodash.noop";
import { Icon as p } from "./index52.mjs";
import I from "classnames";
import a from "./index55.mjs";
import { CHECKBOX_BASE_CLASS as t, CHECKBOX_STATES as c } from "./index56.mjs";
import { ICON_SIZES as v } from "./index54.mjs";
const O = ({ classes: n, state: d, disabled: s, value: r }) => I(
  a[t],
  a[`${t}--${d}`],
  s && a[`${t}--disabled`],
  r && a[`${t}--selected`],
  n
), C = (n) => {
  const {
    classes: d,
    disabled: s,
    id: r,
    name: k,
    onChange: _,
    readonly: m,
    required: h,
    state: b,
    tabindex: S,
    title: $,
    value: o,
    style: g,
    "data-testid": x
  } = n, y = O({
    classes: d,
    state: b,
    disabled: s,
    value: o
  }), u = (l) => {
    !s && !m && _(!o, l);
  }, T = (l) => {
    const { key: A } = l;
    A === "Enter" && u(l);
  }, E = b === c.INDETERMINATE;
  return /* @__PURE__ */ i.createElement(
    "div",
    {
      role: "checkbox",
      "aria-checked": o,
      "data-qa": "click-checkbox",
      className: y,
      onClick: u,
      tabIndex: S,
      onKeyDown: T,
      style: g,
      "data-testid": x
    },
    /* @__PURE__ */ i.createElement(
      "input",
      {
        tabIndex: "-1",
        readOnly: m,
        title: $,
        type: "checkbox",
        name: k,
        id: r,
        checked: o,
        required: h,
        disabled: s,
        onChange: f
      }
    ),
    /* @__PURE__ */ i.createElement("span", { className: `${a[`${t}__background`]}` }),
    !E && o ? /* @__PURE__ */ i.createElement(
      p,
      {
        name: "actions/check",
        size: v.SMALL,
        classes: `${a[`${t}__checkmark`]}`
      }
    ) : null,
    E ? /* @__PURE__ */ i.createElement(
      p,
      {
        name: "actions/line",
        size: v.SMALL,
        classes: `${a[`${t}__line`]}`
      }
    ) : null
  );
};
C.propTypes = {
  classes: e.string,
  disabled: e.bool,
  id: e.string,
  name: e.string,
  onChange: e.func,
  readonly: e.bool,
  required: e.bool,
  state: e.oneOf(Object.values(c)),
  tabindex: e.string,
  title: e.string,
  value: e.bool
};
C.defaultProps = {
  classes: void 0,
  disabled: !1,
  id: void 0,
  name: void 0,
  onChange: f,
  readonly: void 0,
  required: void 0,
  state: c.DEFAULT,
  tabindex: void 0,
  title: void 0,
  value: void 0
};
export {
  c as CHECKBOX_STATES,
  C as Checkbox,
  C as default
};
